import PropTypes from "prop-types"
import React, { Component } from "react"
import GroupRow from "./GroupRow"

const getLayer = (e, lineHeight) => {
  const topDistance = e.clientY - e.target.getBoundingClientRect().top

  return Math.floor(topDistance / lineHeight)
}

export default class GroupRows extends Component {
  static propTypes = {
    canvasWidth: PropTypes.number.isRequired,
    lineCount: PropTypes.number.isRequired,
    groupHeights: PropTypes.arrayOf(PropTypes.number).isRequired,
    onRowMouseMove: PropTypes.func.isRequired,
    onRowClick: PropTypes.func.isRequired,
    onRowMouseOver: PropTypes.func.isRequired,
    onRowMouseOut: PropTypes.func.isRequired,
    onRowDoubleClick: PropTypes.func.isRequired,
    clickTolerance: PropTypes.number.isRequired,
    groups: PropTypes.arrayOf(PropTypes.object).isRequired,
    horizontalLineClassNamesForGroup: PropTypes.func,
    onRowContextClick: PropTypes.func.isRequired,
    onRowMouseUp: PropTypes.func.isRequired,
    onRowMouseDown: PropTypes.func.isRequired,
    lineHeight: PropTypes.number.isRequired,
  }

  static defaultProps = {
    horizontalLineClassNamesForGroup: null,
  }

  shouldComponentUpdate(nextProps) {
    const { canvasWidth, lineCount, groupHeights, groups } = this.props

    return !(
      nextProps.canvasWidth === canvasWidth &&
      nextProps.lineCount === lineCount &&
      nextProps.groupHeights === groupHeights &&
      nextProps.groups === groups
    )
  }

  render() {
    const {
      canvasWidth,
      lineCount,
      groupHeights,
      onRowClick,
      onRowMouseMove,
      onRowMouseOver,
      onRowMouseOut,
      onRowDoubleClick,
      clickTolerance,
      groups,
      horizontalLineClassNamesForGroup,
      onRowContextClick,
      onRowMouseUp,
      onRowMouseDown,
      lineHeight,
      hoverIndex,
      setHoverIndex,
    } = this.props
    const lines = []

    for (let i = 0; i < lineCount; i += 1) {
      /* eslint-disable jsx-a11y/mouse-events-have-key-events */
      lines.push(
        <GroupRow
          clickTolerance={clickTolerance}
          onContextMenu={evt =>
            onRowContextClick(evt, i, getLayer(evt, lineHeight))
          }
          onClick={evt => onRowClick(evt, i, getLayer(evt, lineHeight))}
          onMouseMove={evt => onRowMouseMove(evt, i, getLayer(evt, lineHeight))}
          onMouseOver={evt => onRowMouseOver(evt, i, getLayer(evt, lineHeight))}
          onMouseOut={evt => onRowMouseOut(evt, i, getLayer(evt, lineHeight))}
          onDoubleClick={evt =>
            onRowDoubleClick(evt, i, getLayer(evt, lineHeight))
          }
          onMouseUp={evt => onRowMouseUp(evt, i, getLayer(evt, lineHeight))}
          onMouseDown={evt =>
            onRowMouseDown(evt, groups[i].rowIndex, getLayer(evt, lineHeight))
          }
          key={`horizontal-line-${i}`}
          isEvenRow={i % 2 === 0}
          group={groups[i]}
          horizontalLineClassNamesForGroup={horizontalLineClassNamesForGroup}
          hoverIndex={hoverIndex}
          setHoverIndex={setHoverIndex}
          style={{
            width: `${canvasWidth}px`,
            height: `${groupHeights[i] - 1}px`,
          }}
        />,
      )
      /* eslint-enable jsx-a11y/mouse-events-have-key-events */
    }

    return <div className="rct-horizontal-lines">{lines}</div>
  }
}
